import { AppProviders, LogoContext } from '@jupiterone/jupiter-web-toolkit';
import React from 'react';
import JupiterAppBar from './jupiterAppBar/JupiterAppBar';

const App = () => (
  <AppProviders jssPrefix="navbar" isSessionEmitter={true}>
    <LogoContext.LogoContextProvider>
      <JupiterAppBar />
    </LogoContext.LogoContextProvider>
  </AppProviders>
);
export default App;
